// External Imports
import { IoMdClose } from "react-icons/io";
import { MdComment, MdWarning } from "react-icons/md";
import Modal from "./Modal";
import { useContext, useEffect, useState } from "react";
import LoadingSpinnerWrapper from "./LoadingSpinnerWrapper";
import { requestAdminAPI } from "../../api/posh-api";
import { AuthContext } from "../../context/auth-context";

// Internal Imports

/** ========================================================================
 * * WarningModal Component
 * This component renders a modal that displays a warning.
 * ========================================================================== */

export default function WarningModal({ open, setOpen, warning }) {
  const [report, setReport] = useState(true);
  const [issue, setIssue] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);

  const submitHandler = async () => {
    try {
      setLoading(true);
      const details = document.getElementById("details")?.value;
      const url = window.location.pathname + window.location.search;

      // Send Report
      const response = await requestAdminAPI("report-issue", {
        details,
        warning,
        url,
        email: user.email,
      });
      setIssue(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      setReport(false);
      setIssue(false);
    }
  }, [open]);

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal p-6 lg:max-w-[40vw]">
        <div className="flex items-center justify-between">
          {report ? (
            <div className="flex items-center space-x-2 text-yellow-600">
              <MdComment className="w-5 h-5" />
              <p className="text-lg font-semibold">Report Issue</p>
            </div>
          ) : (
            <div className="flex items-center space-x-2 text-red-700">
              <MdWarning className="w-5 h-5" />
              <p className="text-lg font-semibold">Error</p>
            </div>
          )}
          <IoMdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        {report ? (
          issue ? (
            <div className="grid mb-4 text-center">
              <p className="text-xl font-semibold text-center">
                Issue Reported! ✅
              </p>
              <p className="mt-4 text-stone-200">
                Your report number is{" "}
                <span className="text-lg font-semibold text-white">
                  {issue.title}
                </span>
              </p>
              <p className="mt-4 text-stone-400">
                You will receive a updates via email to {user.email} and on
                slack{" "}
                <a
                  href="https://poshcars.slack.com/archives/C08R3U21PT5"
                  target="_blank"
                  className="text-yellow-600 underline"
                >
                  #tech
                </a>{" "}
                channel.
              </p>
              <p className="mt-1 text-stone-400">
                You can also monitor the status{" "}
                <a
                  href={issue.url}
                  target="_blank"
                  className="text-yellow-600 underline"
                >
                  here.
                </a>
              </p>

              <p className="mt-6 text-lg font-semibold">Thank You! 😍</p>
            </div>
          ) : (
            <div className="grid gap-2">
              <p className="text-stone-200">
                Please briefly describe what you were trying to do when you
                encountered this issue.
              </p>
              <textarea
                type="text"
                id="details"
                className="w-full form-input"
                placeholder="Write details here..."
                rows={5}
                required
              />
              {loading ? (
                <LoadingSpinnerWrapper />
              ) : (
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <div onClick={() => setOpen(false)} className="btn-secondary">
                    Cancel
                  </div>
                  <div onClick={submitHandler} className="btn-primary">
                    Submit
                  </div>
                </div>
              )}
            </div>
          )
        ) : (
          <div className="grid gap-4">
            <p className="font-semibold">{warning}</p>
            {user && (
              <div className="grid gap-2 mt-4 text-center lg:text-left">
                <p className="text-stone-400">
                  If you believe this is a technical error and you have not
                  reported it before, please do so now.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div onClick={() => setOpen(false)} className="btn-secondary">
                    Ignore
                  </div>
                  <div onClick={() => setReport(true)} className="btn-primary">
                    Report Issue
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
